import fetch from '../core/fetch';
import { parseResponse } from '../core/fetch/response';
import AuthorizationHeader from './authorization-header';

export default class Stats {
  static getStatsURL() {
    return `${process.env.REACT_APP_CLIENT_LIBRARY_API}/stats`;
  }

  static async getLevelStats(levelIdArr) {
    const baseUrl = this.getStatsURL();
    const idString = levelIdArr.toString();
    const paramStr = `?playlists-lessons-count-ids=${idString}`;
    const url = `${baseUrl}${paramStr}`;
    const headers = await AuthorizationHeader.getCognitoHeader();
    const response = await fetch(url, {
      method: 'GET',
      ...headers,
    });
    return parseResponse(response);
  }
}
